import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from 'components/Icon';
import { authAPI } from 'utils/api';

export default function AdminLogin() {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState('');
  const nav = useNavigate();

  const handle = async e => {
    e.preventDefault();
    if (!email || !password) { setError('Enter email and password.'); return; }
    setLoading(true); setError('');
    try {
      const res = await authAPI.login({ email, password });
      localStorage.setItem('dl_token', res.data.token);
      nav('/dv-panel-83ca0bcf/dashboard');
    } catch {
      setError('Incorrect credentials. Please try again.');
    } finally { setLoading(false); }
  };

  return (
    <div className="login-pg">
      <div className="login-card">
        <div style={{ textAlign:'center', marginBottom:32 }}>
          <div style={{ width:56, height:56, background:'var(--slate-800)', borderRadius:'var(--r)', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 16px', color:'white' }}>
            <Icon name="lock" size={26} />
          </div>
          <h1 style={{ fontSize:22, fontWeight:800, color:'var(--slate-900)', marginBottom:6 }}>Admin Login</h1>
          <p style={{ color:'var(--slate-400)', fontSize:14 }}>Restricted access. Authorized personnel only.</p>
        </div>
        <form onSubmit={handle}>
          <div className="form-group">
            <label>Email</label>
            <input type="email" className="form-control" placeholder="Enter admin email" value={email} onChange={e => setEmail(e.target.value)} autoFocus />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input type="password" className="form-control" placeholder="Enter password" value={password} onChange={e => setPassword(e.target.value)} />
          </div>
          {error && <div className="alert alert-error"><Icon name="alertCircle" size={16} />{error}</div>}
          <button type="submit" className="btn btn-dark btn-lg btn-full" disabled={loading}>
            {loading ? <><span className="spinner sp-sm" />Logging in...</> : <><Icon name="lock" size={18} />Login</>}
          </button>
        </form>
        <p style={{ textAlign:'center', fontSize:11, color:'var(--slate-300)', marginTop:20 }}>
          Developed by Ethoss Technologies
        </p>
      </div>
    </div>
  );
}
